var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide7LeftBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 186,
    viewBox: "0 0 140 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.039 185.819V96.1599C88.9477 95.724 88.7091 95.3329 88.3634 95.0521C88.0177 94.7714 87.5859 94.6182 87.1406 94.6182C86.6953 94.6182 86.2635 94.7714 85.9178 95.0521C85.5721 95.3329 85.3336 95.724 85.2422 96.1599V185.778L89.039 185.819Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5947 185.819V96.1597C46.5948 95.8804 46.5347 95.6045 46.4183 95.3506C46.302 95.0968 46.1323 94.871 45.9207 94.6888C45.7091 94.5066 45.4606 94.3723 45.1923 94.2949C44.924 94.2176 44.6422 94.199 44.3661 94.2406C43.893 94.3371 43.4687 94.5964 43.167 94.9734C42.8654 95.3505 42.7055 95.8214 42.7153 96.3041V185.798L46.5947 185.819Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1016 0L139.7 152.101H34.5234L87.1016 0Z",
    fill: "#26A69A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6543 22.9258L89.3293 152.101H0L44.6543 22.9258Z",
    fill: "#26C6DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide7LeftBottom);
export default __webpack_public_path__ + "static/media/slide7-left-bottom.1be332b41a7f05c198dc5d36e01e5ab4.svg";
export { ForwardRef as ReactComponent };